import { useCallback, useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

const KEY = 'pgp.theme';

function initial(): Theme {
  const saved = localStorage.getItem(KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  // Light is the intended default. Deliberately not following the device
  // preference: most phones sit on dark, which would hide the light theme
  // from almost everyone who never opens the toggle.
  return 'light';
}

function apply(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}

// Set before first paint so the page never flashes the wrong theme.
apply(initial());

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(initial);

  useEffect(() => {
    apply(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);

  return [theme, toggle];
}
